// Program names often already end with the year (e.g. "Program Loyalty 2025"),
// so strip it before appending to avoid "Program Loyalty 2025 - 2025".
export function formatProgramNameWithYear(
  name: string | null | undefined,
  year: string | number,
) {
  let yearString = year.toString();
  let trailingYear = new RegExp(`[\\s\\-_]*${yearString}\\s*$`);
  let trimmedName = (name ?? '').replace(trailingYear, '').trim();

  return trimmedName ? `${trimmedName} - ${yearString}` : yearString;
}
